export default __webpack_public_path__ + "static/media/heading-values.613ce2cb.png";